'use strict';

var angular = require('angular');
var modules = ['AVRO.Common.Moment', 'AVRO.Common.Formatting'];
module.exports = angular.module('AVRO.PricingSummary.SnapshotSummary', modules).controller('SnapshotSummaryController', require('./controllers/SnapshotSummaryController')).directive('rmSnapshotSummary', require('./directives/SnapshotSummaryDirective'));